export default "__VITE_ASSET__H_jQbjr1__"